<template>
  <AppDialog
    class="members-update-dialog"
    :title="dialogTitle"
    append-to-body
    show
    @close="close"
  >
    <div class="dialog-p">Proceed with current member selection or select all members.</div>

    <div slot="footer">
      <div class="d-flex justify-space-between align-items-center flex-column flex-sm-row mt-40 gap-20">
        <a
          class="nav-link"
          @click="skipToUpload"
        >
          Skip to upload
        </a>
        <div>
          <AppButton
            class="mr-15"
            type="default"
            :disabled="!!apiErrors?.length"
            @click="updateAll"
          >
            Update all members
          </AppButton>
          <AppButton
            type="primary"
            :disabled="!!apiErrors?.length"
            @click="nextStep"
          >
            Proceed
          </AppButton>
        </div>
      </div>
    </div>
  </AppDialog>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'MembersUpdateAllDialog',
  computed: {
    ...mapGetters(['apiErrors', 'batchActionIdsCount', 'totalRecordsCount']),
    dialogTitle() {
      return `Update ${this.batchActionIdsCount} out of ${this.totalRecordsCount} members?`;
    },
  },
  methods: {
    ...mapActions(['setBatchActionIds']),
    close() {
      this.$emit('close');
    },
    skipToUpload() {
      this.$emit('skipToUpload');
    },
    nextStep() {
      this.$emit('nextStep');
    },
    updateAll() {
      this.setBatchActionIds([]);
      this.nextStep();
    },
  },
};
</script>
